import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityAuthenticationResetPasswordPostAsyncSlice } from './post';

export const securityAuthenticationResetPasswordReducers = combineReducers({
	post: securityAuthenticationResetPasswordPostAsyncSlice.asyncReducers
});

export const securityAuthenticationResetPasswordWatchers = combineAllWatchers([
	securityAuthenticationResetPasswordPostAsyncSlice.asyncWatchers
]);
